<template>
  <VeeForm v-slot="{ errors }" as="">
    <div class="flex flex-col justify-between rounded-md w-full">
      <NText
        variant="caption1"
        weight="medium"
        class="w-96 text-neutral-secondary block mt-3 mb-2"
      >
        {{ t('option.strategyEditDialogField') }}
      </NText>
      <form autocomplete="off">
        <VeeField
          v-slot="{ field }"
          v-model="formModel.quantity"
          name="quantity"
          :rules="{
            required: true,
            between: [
              1,
              props.quantity,
              t('تعداد وارد شده از تعداد کل استراتژی شما بیشتر است.'),
            ],
          }"
        >
          <NInput
            v-model="formModel.quantity"
            v-mask="{
              alias: 'positiveNumber',
            }"
            input-class="text-start"
            v-bind="field"
            :error="errors.quantity"
            :show-error="true"
            :required-sign="false"
            type="tel"
            dir="ltr"
            :min="1"
            required
            @focusin="$event.target.select()"
          />
        </VeeField>
      </form>

      <div class="flex gap-2 justify-center items-center mt-3">
        <NButton
          v-gid="{
            module: 'strategies',
            screen: 'home',
            section: 'strategiesEdit',
            component: 'EditStrategiesDialog',
          }"
          variant="fill"
          class="font-bold w-full"
          type="submit"
          size="small"
          :disabled="isLoadingUpdateStrategy"
          :loading="isLoadingUpdateStrategy"
          @click="handleSubmit"
        >
          {{ t('common.submitEdit') }}
        </NButton>

        <NButton
          variant="outline"
          class="font-bold w-full"
          color="red"
          size="small"
          @click="remove()"
        >
          {{ t('common.cancel') }}
        </NButton>
      </div>
    </div>
  </VeeForm>
</template>

<script setup lang="ts">
import { reactive } from 'vue';
import { useI18n } from 'vue-i18n';

import { useQueryClient } from '@libs/use';
import { useDialog, useToast } from '@negar/core';
import { OPTION_QUERY_KEYS, useUpdateStrategyQuery } from '@core/option';

type TDeleteStrategyDialogProps = {
  isin: string;
  quantity: number;
};

const props = defineProps<TDeleteStrategyDialogProps>();

const toast = useToast();
const { t } = useI18n();
const { remove } = useDialog();
const queryClient = useQueryClient();

const formModel = reactive({
  quantity: props.quantity,
});

const { updateStrategy, isLoadingUpdateStrategy } = useUpdateStrategyQuery({
  async onSuccess() {
    toast.neutral({
      message: t('option.strategyMessage.update'),
      duration: 3000,
    });

    queryClient.invalidateQueries(OPTION_QUERY_KEYS.strategies);

    remove();
  },
  onReject: (error) => {
    const message = error.response?.data[0].message;

    if (message) {
      toast.negative({
        message,
        duration: 3000,
      });
    } else {
      toast.negative({
        message: t('option.strategyMessage.error'),
        duration: 3000,
      });
    }
  },
});

const handleSubmit = () => {
  return updateStrategy({ formModel: { ...formModel, isin: props.isin } });
};
</script>
